import { Tooltip, Tag, Button, Space, Avatar, Dropdown, } from "antd";
import {
  EyeOutlined,
  SyncOutlined,
  CheckOutlined,
  CloseOutlined,
  CopyTwoTone,
  FileTextOutlined,
  MoreOutlined,
  EyeTwoTone,
  CopyOutlined,
} from "@ant-design/icons";
import moment from "moment/moment";

import { CopyTextToClipboard } from "../../helpers/copy";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import { FormatDataCustomerJson } from "../../helpers/formatDataJson";
import { tagsBageStatus } from "../../helpers/tagsBage";
import { BankData } from "../../Data/BankData";
import { getTableRowClassName } from "../../helpers/getRowClassName";
import { getIcon } from "../../helpers/getIcon";
import { hasPermission } from "../../utils";
// Columns  รายการธุรกรรมวันนี้
export const ColumnsTab1 = (
  t,
  handleShowDetails,
  handleReSend,
  languageFormat,
  handlePaymentVoucher,
  dropdownPlacement,
  handleShowModelDetelCustomer,
  resProfileAdmin,
) => [

    // ID
    {
      title: t("ID"),
      key: "id",
      dataIndex: "id",
      render: (id, record, index) => {
        const userPermissions = Array.isArray(resProfileAdmin?.permissions)
          ? resProfileAdmin.permissions
          : [];

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = hasPermission(userPermissions, "details_payin");

        return <div
          onClick={() => accessible ? handleShowDetails(record) : alert(t("You do not have permission to view details."))}
          className="text-truncate"
          title={id}
          style={{
            textWrap: "nowrap",
            width: 60,
            display: "inline-block",
            cursor: "pointer", color: "#3eacff"
          }}
        >
          <u>#{id}</u>

        </div>
      },
      sorter: false,
    },

    // Ref
    {
      title: t("Ref"),
      dataIndex: "logUuid",
      key: "logUuid",
      render: (ref) => (
        <div className="d-flex align-items-center">
          <Tooltip key={`tooltip-${ref}`} placement="topLeft" title={ref}>
            <span
              className="text-truncate"
              style={{
                textWrap: "nowrap",
                maxWidth: "120px",
                width: "100%",
                display: "inline-block",
              }}
            >
              {ref}{" "}
            </span>
          </Tooltip>
          <span className="">
            <CopyOutlined
              style={{ cursor: "copy" }}
              className="hover"
              onClick={() => CopyTextToClipboard(ref)}
            />
          </span>
        </div>
      ),
    },

    // createdAt
    {
      title: t("createdAt"),
      filterSearch: true,
      // sorter: (a, b) => {
      //   let timeA = a?.eventCreatedAt || 0;
      //   let timeB = b?.eventCreatedAt || 0;
      //   return timeA - timeB;
      // },
      dataIndex: "created_at",
      key: "created_at",
      render: (date, record) => {
        let created_at =
          record?.eventCreatedAt === 0 ? date : record?.eventCreatedAt;
        return (
          <>
            <span style={{ maxWidth: "60px" }} className="text-truncate">
              <Tooltip
                title={moment(created_at)
                  .locale(languageFormat || "th")
                  .format("YYYY-MM-DD HH:mm:ss")}
              >
                {/* {moment(created_at).locale(languageFormat || "th").format("ll")},{" "}
                <span style={{ fontWeight: "500" }}>
                  {moment(created_at).format("HH:mm:ss")}
                </span>
                <br /> */}
                <span style={{ fontWeight: "500" }}>
                  {FormatTimeAgo(created_at)}
                </span>
              </Tooltip>
            </span>
          </>
        );
      },
    },

    // Account  & Name
    {
      title: (
        <span className="text-truncate">
          {t("customer bank")} <br /> {t("customer name")}
        </span>
      ),
      render: (record) => {
        let item = FormatDataCustomerJson(record.bank);
        let bankCode = item?.bankCode === "kkp" ? "KKP" : item?.bankCode === "TTB" ? "ttb" : item?.bankCode;
        const userPermissions = Array.isArray(resProfileAdmin?.permissions)
          ? resProfileAdmin.permissions
          : [];
        const accessible = hasPermission(userPermissions, "details_customer");

        return (
          <span style={{ textTransform: "uppercase" }}>
            <Avatar
              size={24}
              src={BankData?.find((o) => o?.bank_id === bankCode || o?.bankCode === bankCode)?.bankLogo}
            />{" "}
            -{" "}
            <b className="hover">
              {/* formatPromptPayNumber(item?.accountNo) */}
              {item?.accountNo}{" "}
              <CopyOutlined
                style={{ cursor: "copy" }}
                onClick={() => CopyTextToClipboard(item?.accountNo)}
              />
            </b>{" "}
            <br />
            <span style={{ fontWeight: "600" }}>
              <Tooltip color="blue" title={t("Customer details")}>
                <span className="hover" style={{ cursor: "pointer" }} onClick={() => {
                  if (accessible) {
                    handleShowModelDetelCustomer(record);
                  } else {
                    alert(t("You don't have permission to view customer details"));
                  }
                }}>
                  <EyeTwoTone /> {item?.accountName}
                </span>{" "}
              </Tooltip>{" "}
              <CopyOutlined
                style={{ cursor: "copy" }}
                className="hover"
                onClick={() => CopyTextToClipboard(item?.accountName)}
              />
            </span>
          </span>
        );
      },
    },

    // status
    {
      title: t("status"),
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <Tag
          style={{ textTransform: "uppercase", fontWeight: "700" }}
          icon={getIcon(status)}
          color={tagsBageStatus(status)}
          className={getTableRowClassName(status)}
          key={record?.id}
        >
          {t(status)}
        </Tag>
      ),
    },

    // amount
    {
      title: (
        <span className="text-truncate">
          {t("deposit amt")}
          {/* <br /> {t("tarnsfer amt")} */}
        </span>
      ),
      render: (item) => (
        <>
          <span style={{ textTransform: "uppercase" }}>
            <b className="text-truncate">
              THB {Intl.NumberFormat().format(parseFloat(item.amount).toFixed(2))}
            </b>{" "}
          </span>
        </>
      ),
    },

    // fee
    {
      title: <span className="text-truncate">{t("fee")}</span>,
      dataIndex: "fee",
      key: "fee",
      render: (fee) => (
        <b>{Intl.NumberFormat().format(parseFloat(fee).toFixed(2))}</b>
      ),
    },

    // note
    {
      title: <span className="text-truncate">{t("note")}</span>,
      dataIndex: "note",
      key: "note",
      render: (note) => (
        <div
          className="text-wrap"
          style={{ fontSize: 11, width: 130 }}
          title={note || ""}
        >
          {note || "-"}
        </div>
      ),
    },

    // action
    {
      title: <span className="text-truncate">{t("action")}</span>,
      key: "action",
      render: (_, record) => {
        let statusSuccess = record?.status === "SUCCESS";

        const userPermissions = Array.isArray(resProfileAdmin?.permissions) ? resProfileAdmin.permissions : [];

        const menuItems = [];

        // 1. Details
        if (hasPermission(userPermissions, "details_payin")) {
          menuItems.push({
            key: "Details",
            icon: <EyeOutlined />,
            label: <>{t("Details")}</>,
            onClick: () => handleShowDetails(record),
          });
        }

        // 2. paymentVoucher_payin
        if (hasPermission(userPermissions, "paymentVoucher_payin")) {
          menuItems.push({
            key: "PaymentVoucher",
            icon: <FileTextOutlined />,
            label: <>{t("Payment Voucher")}</>,
            style: { display: statusSuccess ? "" : "none" },
            onClick: () => handlePaymentVoucher(record),
          },);
        }

        // 3. callback_payin
        if (hasPermission(userPermissions, "callback_payin")) {
          menuItems.push({
            key: "ReSend",
            icon: <SyncOutlined />,
            label: <>{t("Re-Send")}</>,
            onClick: () => handleReSend(record),
          },);
        }

        return (
          <Space size="middle">
            <div className="md-show">
              {menuItems.length > 0 && (<><Dropdown
                arrow={true}
                trigger={["click"]}
                placement={dropdownPlacement || "bottomRight"}
                align="start"
                menu={{
                  items: menuItems,
                }}
              >
                <Button shape="circle">
                  <MoreOutlined
                    style={{ color: "#5A5A5A" }}
                    id="MoreOutlined"
                  />

                </Button>
              </Dropdown></>)}

            </div>
          </Space>
        );
      },
    },
  ];



// Columns การอนุมัติการเติมเงิน
export const ColumnsApproveTopup = (
  t,
  handleApproveTopup,
  handleRejected,
  spinIcon,
  languageFormat,
  accessible_approve,
  accessible_reject,
  handleReSend
) => [

    // ID
    {
      title: t("ID "),
      key: "id",
      dataIndex: "id",
      render: (id, record, index) => (
        <div
          className="text-truncate"
          title={id}
          style={{
            textWrap: "nowrap",
            width: 60,
            display: "inline-block",
            cursor: "no-drop",

          }}
        >
          <u>#{id}</u>
        </div>
      ),
      sorter: false,
    },

    // Ref
    {
      title: t("Ref."),
      key: "logUuid",
      dataIndex: "logUuid",
      render: (ref) => (
        <div className="d-flex align-items-center">
          <Tooltip key={`tooltip-${ref}`} placement="topLeft" title={ref}>
            <span
              className="text-truncate"
              style={{
                textWrap: "nowrap",
                maxWidth: "120px",
                width: "100%",

                display: "inline-block",
              }}
            >
              {ref}{" "}
            </span>
          </Tooltip>
          <span className="">
            <i
              className="fa fa-copy"
              onClick={() => {
                CopyTextToClipboard(ref);
              }}
              style={{
                color: "#3eacff",
                fontSize: "17px",
                cursor: "copy",
                marginLeft: "5px",
              }}
            ></i>{" "}
          </span>
        </div>
      ),
    },

    // createdAt
    {
      title: t("txnDate"),
      dataIndex: "eventCreatedAt",
      key: "eventCreatedAt",
      render: (date) => {
        // let created_at = date ? moment(date).locale(languageFormat || "th").format("YYYY-MM-DD HH:mm:ss") : "-";
        // let time = date ? moment(date).locale(languageFormat || "th").format("HH:mm:ss") : "-";

        return <span style={{ maxWidth: "60px" }} className="text-truncate">
          <Tooltip>
            {moment(date).format("YYYY-MM-DD HH:mm:ss")},{" "}
            <span style={{ fontWeight: "500" }}>
              {/* {time} */}
            </span>
          </Tooltip>
        </span>
      },
    },

    // Account No.
    {
      title: <span className="text-truncate">{t("Account No.")}</span>,
      render: (record) => {
        let item = record ? FormatDataCustomerJson(record?.bank) : null;
        let accountNo = item?.accountNo;
        return (
          <span style={{ textTransform: "uppercase" }}>
            <b>
              {accountNo ? (
                <>
                  {accountNo}{" "}
                  <CopyTwoTone
                    style={{ cursor: "copy" }}
                    onClick={() => CopyTextToClipboard(accountNo)}
                  />
                </>
              ) : (
                <em>
                  <small>{t("No data")}</small>
                </em>
              )}
            </b>
          </span>
        );
      },
    },

    // Name
    {
      title: <span className="text-truncate">{t("Name")}</span>,
      render: (record) => {
        let item = FormatDataCustomerJson(record?.bank) || null;
        return (
          <span style={{ textTransform: "uppercase" }}>
            <span style={{ fontWeight: "600" }}>
              {item?.accountName ? (
                <>
                  {item?.accountName}{" "}
                  <CopyTwoTone
                    style={{ cursor: "copy" }}
                    onClick={() => CopyTextToClipboard(item?.accountName)}
                  />
                </>
              ) : (
                <em>
                  <small>{t("No data")}</small>
                </em>
              )}
            </span>
          </span>
        );
      },
    },

    // status
    {
      title: t("status"),
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <Tag
          style={{ textTransform: "uppercase", fontWeight: "700" }}
          icon={getIcon(status)}
          color={tagsBageStatus(status)}
          className={getTableRowClassName(status)}
          key={record?.id}
        >
          {t(status)}
        </Tag>
      ),
    },

    // deposit amt
    {
      title: <span className="text-truncate">{t("deposit amt")}</span>,
      render: (item) => (
        <>
          <span style={{ textTransform: "uppercase" }}>
            <b className="text-truncate">
              THB {Intl.NumberFormat().format(parseFloat(item.amount).toFixed(2))}
            </b>
          </span>
        </>
      ),
    },

    // fee
    {
      title: <span className="text-truncate">{t("fee")}</span>,
      render: (item) => (
        <>
          <span style={{ textTransform: "uppercase" }}>
            <b className="text-truncate">
              {Intl.NumberFormat().format(parseFloat(item?.fee))}
            </b>
          </span>
        </>
      ),
    },

    // note
    {
      title: <span className="text-truncate">{t("note")}</span>,
      dataIndex: "note",
      key: "note",
      render: (note) => (
        <div
          className="text-wrap"
          style={{ fontSize: 11, width: 130 }}
          title={note || ""}
        >
          {note || "-"}
        </div>
      ),
    },

    // action
    {
      title: <span className="text-truncate">{t("action")}</span>,
      key: "action",
      render: (_, record) => {
        let showUpdatedBy = record?.updatedBy !== null && record?.updatedBy !== undefined && record?.updatedBy !== "" && record?.updatedBy !== "system";
        return <>
          {showUpdatedBy ? (
            <code style={{ color: "red" }}>
              {t("Processed by")}: <small>{record?.updatedBy}</small>
            </code>
          ) : <Space
            size="middle"
            style={{
              display: "inline-flex",
            }}
          >
            {/* 1. approve */}
            {accessible_approve && <div title={t("APPROVE")}>
              <Button
                shape="default"
                style={{ textTransform: "uppercase" }}
                variant="outlined"
                children={t("APPROVE")}
                size="small"
                color="blue"
                onClick={() => handleApproveTopup(record)} // Ensure handleShow is passed
                loading={record.id === spinIcon}
                icon={record.id === spinIcon ? null : <CheckOutlined />}
              />
            </div>}

            {/* 2. rejectUX */}
            {accessible_reject && <div title={t("REJECTED")}>
              <Button
                shape="default"
                style={{ textTransform: "uppercase" }}
                danger
                children={t("REJECTED")}
                loading={record.id === spinIcon}
                variant="outlined"
                size="small"
                onClick={() => handleRejected(record, "REJECTED", "Search")}
                icon={record.id === spinIcon ? null : <CloseOutlined />}
              />
            </div>}

            <div title={t("Callback")}>
              <Button
                shape="default"
                style={{ textTransform: "uppercase" }}
                children={t("CB")}
                loading={record.id === spinIcon}
                variant="outlined"
                size="small"
                onClick={() => handleReSend(record)}
                icon={record.id === spinIcon ? null : <SyncOutlined />}
              />
            </div>

          </Space>}
        </>
      },
    },
  ];

